module.exports = __webpack_public_path__ + "media/src/assets/Images/dots-vertical-9145aae184eeee3a29bd15be680bdc56.svg";